const en = {
  melhous: "MELHOUS",
  "melhous.service": "Services",
  "melhous.item_service": "Service Items",
  "melhous.special_services": "Special Services",
  "melhous.other_services": "Other Services",
  "melhous.gallery_areas": "Gallery",
  "melhous.title": "Title",
  "melhous.banner": "Banner",
  "melhous.desc": "Description",
  "melhous.address": "Address",
  "melhous.url": "URL",
  "melhous.wifi": "WiFi",
  "melhous.wifi_pass": "WiFi Password",
  "melhous.phone": "Phone",
  "melhous.reception_phone": "Reception Phone",
  "melhous.reception_phone2": "Reception Phone 2",
  "melhous.reception_phone3": "Reception Phone 3",
  "melhous.breakfast_start": "Breakfast Start",
  "melhous.breakfast_end": "Breakfast End",
  "melhous.lunch_start": "Lunch Start",
  "melhous.lunch_end": "Lunch End",
  "melhous.meal_start": "Dinner Start",
  "melhous.meal_end": "Dinner End",
  "melhous.check_in": "Check-In",
  "melhous.check_out": "Check-Out",
  "melhous.title_gallery": "Gallery Title",
  "melhous.desc_gallery": "Gallery Description",
  "melhous.service.title": "Title",
  "melhous.service.icon": "Icon",
  "melhous.service.button": "Button",
  "melhous.service.description": "Description",
  "melhous.item_service.title": "Title",
  "melhous.item_service.description": "Description",
  "melhous.item_service.icon": "Icon",
  "melhous.special_services.title": "Title",
  "melhous.special_services.image": "Image",
  "melhous.special_services.note": "Note",
  "melhous.special_services.permitted": "Permitted",
  "melhous.special_services.description": "Description",
  "melhous.other_services.title": "Title",
  "melhous.other_services.icon": "Icon",
  "melhous.other_services.description": "Description",
  "melhous.gallery_areas.title": "Title",
  "melhous.gallery_areas.image": "Image",
  "melhous.gallery_areas.video": "Video",
  "melhous.gallery_areas.desc": "Description",
  "crm.customer_service": "PQRS",
  "crm.customer_service.number": "Number",
  "crm.customer_service.state": "State",
  "crm.customer_service.party": "Party",
  "crm.customer_service.customer": "Customer",
  "crm.customer_service.address": "Address",
  "crm.customer_service.phone": "Phone",
  "crm.customer_service.city": "City",
  "crm.customer_service.case": "Case",
  "crm.customer_service.media": "Media",
  "crm.customer_service.description": "Description",
  "crm.customer_service.diagnose": "Diagnose",
  "crm.customer_service.response": "Response",
  "crm.customer_service.cs_date": "Date",
  "crm.customer_service.effective_date": "Effective Date",
  "crm.customer_service.satisfaction": "Satisfaction",
  "crm.customer_service.efficacy": "Efficacy",
  "crm.customer_service.responsible_employee": "Responsible",
  "crm.customer_service.department": "Department",
  "crm.customer_service.notes": "Notes",
  "crm.customer_service.action_plan": "Action Plan",
  "crm.customer_service.category_customer": "Category",
  "crm.customer_service.draft": "Draft",
  "crm.customer_service.open": "Open",
  "crm.customer_service.close": "Closed",
  "melhous.link_melhous": "Melhous Link (app URL, used in QR codes)",
  "melhous.require_table_qr": "Require Table QR",
  "melhous.guide_items": "Guide",
  "melhous.messages": "Messages",
  "melhous.request_types": "Request Types",
  "melhous.recommendations": "Recommendations",
  "melhous.guide_item": "Guide",
  "melhous.guide_item.section": "Section",
  "melhous.guide_item.title": "Title",
  "melhous.guide_item.description": "Description",
  "melhous.guide_item.schedule": "Schedule",
  "melhous.guide_item.link": "Link",
  "melhous.guide_item.sequence": "Sequence",
  "melhous.guide_item.hotel": "Hotel",
  "melhous.guide_item.nearby": "Nearby",
  "melhous.message": "Messages",
  "melhous.message.title": "Title",
  "melhous.message.body": "Message",
  "melhous.message.kind": "Type",
  "melhous.message.start": "Start",
  "melhous.message.end": "End",
  "melhous.message.active": "Active",
  "melhous.message.info": "Information",
  "melhous.message.promo": "Promotion",
  "melhous.message.alert": "Alert",
  "melhous.request_type": "Request Types",
  "melhous.request_type.name": "Name",
  "melhous.request_type.scope": "Scope",
  "melhous.request_type.active": "Active",
  "melhous.request_type.sequence": "Sequence",
  "melhous.request_type.table": "Table",
  "melhous.request_type.room": "Room",
  "melhous.request_type.both": "Table and Room",
  "melhous.request": "Requests",
  "melhous.request.type": "Type",
  "melhous.request.type_name": "Request",
  "melhous.request.scope": "Scope",
  "melhous.request.shop": "Shop",
  "melhous.request.place": "Place",
  "melhous.request.note": "Note",
  "melhous.request.state": "State",
  "melhous.request.attended_date": "Attended Date",
  "melhous.request.attend": "Attend",
  "melhous.request.pending": "Pending",
  "melhous.request.attended": "Attended",
  "melhous.request.table": "Table",
  "melhous.request.room": "Room",
  "melhous.recommendation": "Recommendations",
  "melhous.recommendation.name": "Name",
  "melhous.recommendation.message": "Message",
  "melhous.recommendation.trigger_category": "When Category",
  "melhous.recommendation.trigger_product": "When Product",
  "melhous.recommendation.active": "Active",
  "melhous.recommendation.sequence": "Sequence",
  "melhous.services": "Services",
  "melhous.special_services.icon": "Icon",
  "melhous.dash.help": "Serve your guests: requests, stay guide, messages and PQRS.",
  "melhous.dash.tab.home": "Home",
  "melhous.dash.tab.hotel": "Hotel",
  "melhous.dash.tab.engage": "Guest Care",
  "melhous.dash.tab.requests": "Requests",
  "melhous.dash.tab.pqrs": "PQRS",
  "melhous.dash.tab.appearance": "Appearance",
  "melhous.dash.card.pending_requests": "Pending requests",
  "melhous.dash.card.active_messages": "Active messages",
  "melhous.dash.card.guide_items": "Guide",
  "melhous.dash.card.open_pqrs": "Open PQRS",
  "melhous.dash.hotel_notice": "Hotel data (information, schedules, services and gallery) is edited directly in Tryton > Melhous > Configuration.",
  "melhous.dash.recommendation_notice": "The recommended products of each rule are chosen in Tryton.",
  "melhous.dash.qr.melhous": "QR for Melhous",
  "melhous.dash.qr.restaurant": "QR for restaurant",
  "melhous.dash.qr.hotel": "QR for hotel",
  "melhous.dash.save": "Save changes",
  "melhous.dash.create": "Create configuration",
  "melhous.dash.saved": "Saved successfully",
  "melhous.primary_color": "Primary color",
  "melhous.secondary_color": "Secondary color",
  "melhous.accent_color": "Accent color",
  "melhous.text_color": "Text color",
  "melhous.surface_color": "Surface color",
  "melhous.border_color": "Border color",
  "melhous.show_hotel": "Show Hotel",
  "melhous.show_restaurant": "Show Restaurants",
  "melhous.show_pqrs": "Show PQRS",
  "melhous.show_reservation": "Show Reservation",
  "melhous.show_experiences": "Show Experiences",
  "melhous.logo_link": "Logo link",
  "melhous.dash.colors": "Colors",
  "melhous.dash.sections": "Sections",
  "melhous.dash.color.invalid": "Use a hex color, e.g. #1f3a5f",
  "melhous.dash.color.no_aa": "No AA",
  "melhous.dash.preview.title": "Preview",
  "melhous.dash.preview.text": "This is how cards and text will look in the app.",
  "melhous.dash.preview.button": "Button",
};

export default en;
